<template>
  <div>
    <div v-if="isEditing">
      <el-form-item prop="title" label="题目">
        <wjQuillEditor
          :content="tempQuesData.title"
          :config="config"
          @onChange="handleEditorChange"
        ></wjQuillEditor>
      </el-form-item>
      <el-form-item label="备注">
        <el-input class="editor-input" v-model="tempQuesData.description"></el-input>
      </el-form-item>
      <el-collapse
        v-model="advancedSetting"
        @change="handleDefaultSettingChange"
        class="batchChange backgroundGray"
      >
        <el-collapse-item name="1">
          <template slot="title">
            <div class="advanced-setting-title backgroundGray">
              <span class="more-setting-btn">
                {{advancedSettingTitle}}
                <i :class="advanceSettingIcon"></i>
              </span>
            </div>
          </template>
          <div class="backgroundGray">
            <el-checkbox label="设置为评测题目" v-model="tempQuesData.evaluateFlag"></el-checkbox>
            <span v-if="tempQuesData.evaluateFlag" class="left20">
              <label>设置正确答案</label>
              <el-input class="right-anwser-input" v-model="anwser"></el-input>
            </span>
            <span v-if="tempQuesData.evaluateFlag" class="left20">
              <label>题目分值</label>
              <el-input-number
                v-model="tempQuesData.assess.score"
                controls-position="right"
                :min="1"
                :max="100"
                size="mini"
              ></el-input-number>
            </span>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-else>
      <div class="ques-title">
        {{ ques.index + 1 }}.
        <p style="display: inline-block;" v-html="ques.title"></p>
        <i v-if="ques.required" class="required-icon">*</i>
      </div>
      <p class="ques-desc">{{ ques.description }}</p>
    </div>
  </div>
</template>
<script>
import { uuid } from "../utils/utils";
import wjQuillEditor from "./wj-quill-editor.vue";
import { quesMixin } from '../utils/mixins'
export default {
  name: "textMultiple",
  mixins: [quesMixin],
  data() {
    return {
      anwser: this.tempQuesData ? this.tempQuesData.assess.options[0] || "" : ""
    };
  },
  props: ["tempQuesData", "isEditing", "ques", "config"],
  watch: {
    anwser(val) {
      this.tempQuesData.assess.options[0] = val;
    }
  },
  components: {
    wjQuillEditor
  },
  methods: {
    transforTitle(str) {
      const self = this;
      let regUnderline = /_+/g;
      let count = 0;
      self.tempQuesData.blankSetting = [];
      let newTitle = str.replace(regUnderline, function(underlines) {
        let inputStr =
          '<input class="textMultiple" v-model="ques.blankSetting[' +
          count +
          '].value" type="text" style="width:' +
          Math.floor(underlines.length * 8.9) +
          'px"' +
          ">";
        self.tempQuesData.blankSetting.push({
          id: uuid(),
          validate: null,
          type: "question",
          attach_id: null,
          value: ""
        });
        count++;
        return inputStr;
      });
      return newTitle;
    },
    handleEditorChange(data) {
      this.tempQuesData.title = data;
    },
    handleDefaultSettingChange(val) {
      if (this.tempQuesData.evaluateFlag) {
        this.tempQuesData.assess.options[0] = this.anwser;
      }
      this.handleSettingChange(val);
    }
  }
};
</script>
<style lang="scss">
.right-anwser-input {
  width: 200px;
  display: inline-block;
  height: 28px;
  .el-input__inner {
    height: 28px;
  }
  input {
    height: 28px;
    line-height: 14px;
    font-size: 14px;
    padding: 7px;
  }
}
.left20 {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/text-multiple.vue